const processing = new Set(['queued', 'running']);

// A confirmed addition changes the queue, never the quote route. Keep ready or
// exceptional unsent parts visible before switching to processing or sent items.
export function afterImportSend(jobs, confirmedIds = []) {
  const confirmed = new Set(confirmedIds);
  const pending = (jobs || []).filter(job => job.state !== 'failed' && !confirmed.has(job.id) && !job.quote_preparation?.sent_line_id);
  const review = pending.filter(job => !processing.has(job.state));
  if (review.length) return { tab: 'to_quote', selected: review[0].id };
  if (pending.length) return { tab: 'processing', selected: pending[0].id };
  const sent = (jobs || []).find(job => confirmed.has(job.id) || job.quote_preparation?.sent_line_id);
  if (sent) return { tab: 'sent', selected: sent.id };
  const failed = (jobs || []).find(job => job.state === 'failed');
  return { tab: failed ? 'history' : 'sent', selected: failed?.id || null };
}

export function markImportsSent(jobs, confirmed) {
  return (jobs || []).map(job => confirmed[job.id] ? {
    ...job, quote_preparation: { ...job.quote_preparation, sent_line_id: confirmed[job.id] },
  } : job);
}

export function mergeImportSummaries(current, summaries) {
  const previous = new Map((current || []).map(job => [job.id, job]));
  return (summaries || []).map(job => {
    const old = previous.get(job.id);
    const metadata = JSON.stringify(job.result || null);
    if (old?._preview_loaded && old.state === job.state && old._preview_metadata === metadata) {
      return {...job, result: old.result, _preview_loaded: true, _preview_metadata: metadata};
    }
    return {...job, _preview_loaded: false, _preview_metadata: metadata};
  });
}
